import { useEffect, useState } from 'react';
import axios from 'axios';
import { Button } from '@/components/ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Someone who asked to delete their account sees only this until they decide. Sits over the whole
 * app so they cannot carry on using it during the 60 days, but can still change their mind.
 */
export const PendingDeletionGate = () => {
  const [pending, setPending] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('token')) return;
    axios.get(`${API}/account/deletion`)
      .then((r) => setPending(r.data.pending ? r.data : null))
      .catch(() => {});
  }, []);

  if (!pending) return null;

  const keep = async () => {
    setBusy(true);
    try {
      await axios.delete(`${API}/account/deletion`);
      window.location.href = '/dashboard';
    } finally {
      setBusy(false);
    }
  };

  const leave = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/';
  };

  const closes = new Date(pending.scheduled_for).toLocaleDateString(undefined, {
    month: 'long', day: 'numeric', year: 'numeric',
  });

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center px-6
                 bg-gradient-to-b from-[#0d1128] to-[#060814]"
      data-testid="pending-deletion-gate"
    >
      <div className="max-w-md text-center space-y-6">
        <h1 className="font-serif text-3xl text-white">Your account is closing</h1>
        <p className="text-white/70 leading-relaxed">
          You asked us to delete your account, and it closes on <strong>{closes}</strong>.
          Nothing has been removed yet. If you would like to carry on, you can pick up exactly
          where you left off.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button onClick={keep} disabled={busy} data-testid="pending-deletion-keep-btn">
            Keep my account
          </Button>
          <Button variant="outline" onClick={leave} className="border-white/20 text-white
                   hover:bg-white/10" data-testid="pending-deletion-signout-btn">
            Sign out
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PendingDeletionGate;
